import React from 'react';
import CalendarWeekDayColumn from './CalendarWeekDayColumn';
import { PLANNER_EMPTY_DAY_EVENTS_LIST } from '../viewServices/calendar_grid_utils';
import { PLANNER_TIME_FORMAT_24 } from '../../moduleServices/planner_time_format';

export const CALENDAR_YEAR_SPAN_BACK = 2;
export const CALENDAR_YEAR_SPAN_FORWARD = 2;

export function generateWeeksForInclusiveYearRange(yearFrom, yearTo) {
  const y0 = Math.min(yearFrom, yearTo);
  const y1 = Math.max(yearFrom, yearTo);
  const weeks = [];
  const firstDay = new Date(y0, 0, 1);
  const firstDayOfWeek = firstDay.getDay();
  const startDate = new Date(firstDay);
  startDate.setDate(startDate.getDate() - firstDayOfWeek);
  const endDate = new Date(y1, 11, 31);
  const endSaturday = new Date(endDate);
  endSaturday.setDate(endSaturday.getDate() + (6 - endSaturday.getDay()));

  let currentDate = new Date(startDate);
  while (currentDate <= endSaturday) {
    const weekDays = [];
    for (let day = 0; day < 7; day++) {
      weekDays.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    weeks.push(weekDays);
  }
  return weeks;
}

export function generateWeeksForFiveYears(centerYear) {
  return generateWeeksForInclusiveYearRange(
    centerYear - CALENDAR_YEAR_SPAN_BACK,
    centerYear + CALENDAR_YEAR_SPAN_FORWARD,
  );
}

/** Uma linha da grelha mensal: sete colunas, eventos apenas dentro de cada célula. */
export const CalendarWeekRow = React.memo(function CalendarWeekRow({
  week,
  referenceMonth,
  todayKey,
  eventsByDateKey,
  onDayClick,
  onEventClick,
  rowHeightPx,
  timeFormatPreference = PLANNER_TIME_FORMAT_24,
  /** From `useDevice().isMobile` — taps on chips open day sheet instead of edit */
  calendarMonthChipMobileUx = false,
}) {
  const month = referenceMonth.getMonth();
  const year = referenceMonth.getFullYear();

  return (
    <div
      className="relative box-border min-h-0 w-full overflow-hidden border-b border-gray-200 bg-white"
      style={{
        height: rowHeightPx,
        minHeight: rowHeightPx,
        maxHeight: rowHeightPx,
      }}
    >
      <div className="relative grid h-full min-h-0 grid-cols-7">
        {week.map((date) => {
          const dk = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
          const isCurrentMonth =
            date.getMonth() === month && date.getFullYear() === year;
          const isToday = dk === todayKey;
          const dayEvents = eventsByDateKey.get(dk) ?? PLANNER_EMPTY_DAY_EVENTS_LIST;
          return (
            <CalendarWeekDayColumn
              key={dk}
              date={date}
              dateKey={dk}
              isCurrentMonth={isCurrentMonth}
              isToday={isToday}
              dayEvents={dayEvents}
              weekRowHeightPx={rowHeightPx}
              onDayClick={onDayClick}
              onEventClick={onEventClick}
              timeFormatPreference={timeFormatPreference}
              calendarMonthChipMobileUx={calendarMonthChipMobileUx}
            />
          );
        })}
      </div>
    </div>
  );
});

CalendarWeekRow.displayName = 'CalendarWeekRow';

export default function CalendarMonthView() {
  return null;
}

export {
  DEFAULT_WEEK_MULTI_BAND_RESERVED_PX,
  WEEK_TOP_ABOVE_TIMED_PX,
  DAY_HEADING_ROW_PX,
} from '../viewServices/calendar_week_multiday_layout';
